import { FormControl, FormLabel, FormHelperText, OutlinedInput, OutlinedInputProps } from '@material-ui/core';
import { useField } from 'formik';
import useCommonStyles from '../../useCommonStyles';

export interface OutlinedInputFieldProps extends Omit<OutlinedInputProps, 'value' | 'onChange'> {
    name: string;
}

const OutlinedDateInputField = ({ name, label, ...props }: OutlinedInputFieldProps) => {
    const { disabled } = props;
    const [{ value, ...field }, meta] = useField({ name });
    const commonStyles = useCommonStyles();

    const hasError = !!meta.error && meta.touched;

    return (
        <FormControl fullWidth>
            {label && (
                <FormLabel className={commonStyles.formLabel} disabled={disabled}>
                    {label}
                </FormLabel>
            )}
            <OutlinedInput
                // by default auto complete is off but props can always override it
                autoComplete="off"
                // spread props
                {...props}
                // the error is defined from what we go in meta data
                error={hasError}
                // provide the value but override null values with undefined
                value={value === null ? undefined : value}
                // then spread the field properties itself
                {...field}
            />
            <FormHelperText error={hasError}>{hasError ? meta.error : ''}</FormHelperText>
        </FormControl>
    );
};

export default OutlinedDateInputField;
